"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLimitOffset = void 0;

var _constants = require("./constants");

var getLimitOffset = function getLimitOffset() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var inputLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var limit = inputLimit ? inputLimit : _constants.PAGE_SIZE;
  var offset = (page - 1) * limit;
  return {
    limit: limit,
    offset: offset,
    page_size: limit
  };
};

exports.getLimitOffset = getLimitOffset;